import { CreateBusinessCustomerPayload } from "src/@types/customer";
import axiosInstance from "../utils/axios";

const EXTEND_URL = "/customers/users/v1";
const BUSINESS_CUSTOMERS_URL = "/customers/business/v1";

//
//

function customerUserApi(email: string, includeLoginMethods?: boolean) {
  const includeLoginMethodsParam =
    includeLoginMethods != null
      ? "&includeLoginMethods=" + !!includeLoginMethods
      : "";

  const encodedEmail = encodeURIComponent(email);

  return axiosInstance
    .get(`${EXTEND_URL}?email=${encodedEmail}${includeLoginMethodsParam}`);
}

function createMerchantCustomerApi(data: any) {
  return axiosInstance.post(`/customers/v1`, JSON.stringify(data));
}

function updateUserApi(email: string, updateLastSignedInAt: boolean) {
  const encodedEmail = encodeURIComponent(email);
  return axiosInstance.patch(`${EXTEND_URL}?email=${encodedEmail}`, JSON.stringify({ updateLastSignedInAt }))
}

export const getBusinessCustomersList = ({ merchantCode }: { merchantCode: string }) => {
  return axiosInstance.get(`${BUSINESS_CUSTOMERS_URL}?merchantCode=${merchantCode}`);
}

export const getBusinessCustomerById = ({ id }: { id: string }) => {
  return axiosInstance.get(`${BUSINESS_CUSTOMERS_URL}/${id}`);
}

export const createBusinessCustomer = ({ payload }: { payload: CreateBusinessCustomerPayload }) => {
  return axiosInstance.post(BUSINESS_CUSTOMERS_URL, JSON.stringify(payload));
}

export const editBusinessCustomer = ({ id, payload }: { id: string, payload: CreateBusinessCustomerPayload }) => {
  return axiosInstance.patch(`${BUSINESS_CUSTOMERS_URL}/${id}`, JSON.stringify(payload));
}

export const deleteBusinessCustomerById = (id: string) => {
  return axiosInstance.delete(`${BUSINESS_CUSTOMERS_URL}/${id}`);
}

export { customerUserApi, createMerchantCustomerApi, updateUserApi };